import { connect, disconnect } from "@giantmachines/redux-websocket/dist";
import { batch } from "react-redux";
import { DialogType } from "../DialogHandler";
import { connectionState, getDisplayState } from "../features/connection/connectionSlice";
import { getConnectionArgs } from "../features/init/initSlice";
import { roomSlice } from "../features/room/roomSlice";
import { roomsSlice } from "../features/rooms/roomsSlice";
import { userSlice, getAuth } from "../features/user/userSlice";
import { viewSlice } from "../features/view/viewSlice";

const cleanupJoinRoom = (obj) => {
  let newObj =  {}
  for (const p of Object.getOwnPropertyNames(obj)) {
    switch (p) {
      case 'time': {
        newObj[p] = parseInt(obj[p]);
        break;
      }
      default: {
        newObj[p] = obj[p];
        break;
      }
    }
  }
  return newObj;
}

const cleanupRoom = (obj) => {
  let newObj =  {}
  for (const p of Object.getOwnPropertyNames(obj)) {
    switch (p) {
      case 'id':
      case 'max_limit':
      case 'room_order':
      case 'users_online': {
        newObj[p] = parseInt(obj[p]);
        break;
      }
      default: {
        newObj[p] = obj[p];
        break;
      }
    }
  }
  return newObj;
}

export const call = (payload, store) => {
  const state = store.getState();
  const dispatch = store.dispatch;
  let auth = getAuth(state);

  // Do not pass auth when doing login
  if (payload.func === 'login') {
    auth = {};
  }

  const connectionArgs = getConnectionArgs(state);
  const args = {...payload.args, 'func': payload.func, ...auth};

  const querystring = Object.entries(args).map(v => {
    const [key, value] = v;
    return encodeURIComponent(key)+'='+encodeURIComponent(value);
  }).join('&');

  fetch('https://'+connectionArgs.apiDomain+'/wk-api.php?'+querystring)
    .then(res => res.json())
    .then(res => {
      if (res.result === 'false') {
        if (res.code === 'user_auth_error') {
          dispatch(userSlice.actions.resetSession());

          // If we did the call with auth and we failed auth lets retry it without
          if (Object.keys(auth).length > 0) {
            call(payload, store);
          }
        }
        return;
      }

      switch (payload.func) {
        case 'get_rooms': {
          const rooms = res.map(r => cleanupRoom(r));
          batch(() => {
            rooms.map(r => dispatch(roomsSlice.actions.addRoom(r)));
            if (connectionArgs !== null && connectionArgs.roomID !== undefined) {
              dispatch({type: 'action/joinroom', payload: { id: connectionArgs.roomID }});
            }
          });
          break;
        }
        case 'join_room': {
          const r = cleanupJoinRoom(res);
          const s = getDisplayState(state);
          batch(() => {
            dispatch(roomSlice.actions.setConnectionArgs(r));
            if (s !== connectionState.CONNECTED) {
              dispatch(connect(r.url, ['binary']));
            } else {
              dispatch(disconnect());
            }
          });
          break;
        }
        case 'login': {
          // TODO handle errors
          batch(() => {
            dispatch(userSlice.actions.setSession({id: res.userid, authkey: res.authkey}));
            dispatch(viewSlice.actions.closeDialog(DialogType.LOGIN));
            if (payload.payload.roomID !== undefined) {
              dispatch({type: 'action/joinroom', payload: { id: payload.payload.roomID }});
            }
          });
          break;
        }
        default: {
          throw new Error('Do not know how to handle '+payload.func);
        }
      }
    });
};